import {Compiler, Component, OnInit} from '@angular/core';
import {RegisterEtaxComponent} from '../../account/register-etax/register-etax.component';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from '../../idex.service';
import {TranslateService} from '@ngx-translate/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {Toast} from '../../shared/toast/toast';

declare var $: any;

@Component({
   selector: 'app-setting-etax-menu',
   templateUrl: './setting-etax-menu.component.html',
   styleUrls: ['./setting-etax-menu.component.css']
})
export class SettingEtaxMenuComponent implements OnInit {
   public companyName: any;
   public companyStatus: any;
   public companyTin: any;
   data: any;
   showMailServer: boolean;
   server: string;
   port: any;
   etaxEmail: string;
   etaxPassword: string;
   dataInfo: any;
   public saveText: any;
   public checkButton = false;

   isEnableServer = false;
   isEnablePort = false;
   isEnableInput = false;

   constructor(private route: ActivatedRoute,
               protected service: IdexService,
               private compiler: Compiler,
               private translate: TranslateService,
               private dialog: MatDialog,
               private router: Router,
               private toast: Toast) {
   }

   ngOnInit() {
      localStorage.removeItem('sortOrder');
      localStorage.removeItem('sortDirect');
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
      this.getCompanyInfo();
   }

   getCompanyInfo() {
      this.companyName = window.localStorage.getItem('data_company');
      this.companyStatus = window.localStorage.getItem('status');
      this.companyTin = window.localStorage.getItem('tin');
      this.service.getCompanyInfo(this.companyName)
         .subscribe(
            data => {
               this.data = data;
               this.companyStatus = this.data.status;
               this.companyTin = this.data.tin;
               if (this.companyStatus === 'A' || this.companyStatus === 'N') {
                  this.service.get('/work/' + this.data.tin + '/info')
                     .subscribe(
                        dataInfo => {
                           this.dataInfo = dataInfo;
                           this.etaxEmail = this.dataInfo.username;
                           this.detectMailServer(this.etaxEmail);
                           this.etaxPassword = this.dataInfo.password;
                           this.server = this.dataInfo.server;
                           this.port = this.dataInfo.port;
                        });
               }
            });
   }

   openEtaxByEmail(): void {
      const etaxInvoice = this.dialog.open(RegisterEtaxComponent, {
         disableClose: true,
         data: {name: this.companyName, tin: this.companyTin, service: this.service}
      });
      this.translate.get('register_dashboard_title').subscribe((msg) => {
         etaxInvoice.componentInstance.title = msg;
      });
      etaxInvoice.afterClosed().subscribe(result => {
         if (result) {
            this.ngOnInit();
         }
      });
   }

   detectMailServer(email: any) {
      if (email != null) {
         const i = email.indexOf('@');
         const domain = i === -1 ? '' : email.substr(i + 1);
         this.showMailServer = domain.length > 0 && domain !== 'gmail.com' && domain !== 'outlook.com'
            && domain !== 'hotmail.com' && domain !== 'icloud.com' && domain !== 'yahoo.com';

         if (!this.showMailServer) {
            this.isEnableServer = false;
            this.isEnablePort = false;
            $('.hide-input').hide();
            this.server = '';
            this.port = 993;
         } else if (this.showMailServer && this.checkButton) {
            this.isEnableServer = true;
            this.isEnablePort = true;
            $('.hide-input').show();
         }
      }
   }

   onSave(btnSave: MatButton, btnCancel: MatButton) {
      btnSave.disabled = true;
      btnCancel.disabled = true;
      const body = {
         username: this.etaxEmail,
         password: this.etaxPassword,
         server: this.server,
         port: this.port
      };
      this.service.put('/work/' + this.companyTin + '/update/info', body, {responseType: 'text'})
         .subscribe(response => {
               this.translate.get('saving').subscribe(s => {
                  this.saveText = s;
                  setTimeout(() => {
                     btnSave.disabled = false;
                     btnCancel.disabled = false;
                     this.translate.get('save').subscribe(save => {
                        this.saveText = save;
                        this.toast.success(response);
                        this.ngOnInit();
                     });
                  }, 5000);
               });

            }, error => {
               this.toast.error(error.message);
               btnSave.disabled = false;
               btnCancel.disabled = false;
               this.translate.get('save').subscribe(s => {
                  this.saveText = s;
               });
            });

   }

   onCancel() {
      this.etaxEmail = this.dataInfo.username;
      this.detectMailServer(this.etaxEmail);
      this.etaxPassword = this.dataInfo.password;
      this.server = this.dataInfo.server;
      this.port = this.dataInfo.port;
      this.checkButton = false;
      this.isEnableServer = false;
      this.isEnablePort = false;
      this.isEnableInput = false;
      document.getElementById('btn_edit').style.display = 'inline-block';
      document.getElementById('btn_cancel').style.display = 'none';
      document.getElementById('btn_saveType').style.display = 'none';
   }

   onEdit() {
      this.checkButton = true;
      this.isEnableServer = true;
      this.isEnablePort = true;
      this.isEnableInput = true;
      document.getElementById('btn_edit').style.display = 'none';
      document.getElementById('btn_cancel').style.display = 'inline-block';
      document.getElementById('btn_saveType').style.display = 'inline-block';
   }

}
